import { render } from "./SubscribeButton.vue?vue&type=template&id=5b559b1a&scoped=true"
import script from "./SubscribeButton.vue?vue&type=script&lang=js"
export * from "./SubscribeButton.vue?vue&type=script&lang=js"

import "./SubscribeButton.vue?vue&type=style&index=0&id=5b559b1a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b559b1a"]])

export default __exports__